const UPCOMING_BADGE = 'Next';

function showPageLoader() {
  document.body.insertAdjacentHTML(
    'beforeend',
    `
    <div class="align-items-center d-flex justify-content-center page-backdrop">
      <div class="align-items-center bg-white border border-1 d-flex p-3 rounded shadow-sm" role="alert" aria-live="assertive" tabindex="-1">
        <div class="spinner-border me-3" role="status" aria-hidden="true"></div>
        <span class="fs-5">Updating Page</span>
      </div>
    </div>
    <div id="loading-status" aria-live="polite" aria-atomic="true" class="visually-hidden">Updating Page...</div>
  `
  );
  document.body.classList.add('overflow-hidden');
  const liveRegion = document.getElementById('loading-status');
  setInterval(() => {
    if (liveRegion) liveRegion.textContent = 'Updating Page...';
  }, 3000);
}

export class EditionReleaseSelect {
  constructor(element) {
    this.element = element;
    this.customSelect = element.querySelector('.customSelect');
    this.upcomingOption = this.customSelect?.querySelector('.customSelectOption.isUpcoming');
    this.upcomingAlert = element.querySelector('.upcomingReleaseAlert');
    this.upcomingBadgeOption = element.querySelector('.customSelectOption.isUpcoming.current');
    this.inputBadge = element.querySelector('.customSelect .form-select .badge');

    if (this.upcomingOption && this.upcomingAlert) {
      const url = new URL(window.location.href);
      url.searchParams.delete('edition');
      url.searchParams.set('release', this.upcomingOption.dataset.value);
      url.searchParams.set('viewOption', 'instructor');
      this.upcomingAlert.querySelector('a')?.setAttribute('href', url.toString());
    }

    document.addEventListener('customSelectChange', (event) => {
      const selectedOption = event.target;
      if (!this.element.contains(selectedOption)) return;

      const url = this.generateUrl(event.detail?.value, selectedOption.classList.contains('isEdition'));
      if (selectedOption.matches('.customSelectOption')) {
        selectedOption.dispatchEvent(
          new CustomEvent('mhecomm-he-pdp-edition-release-select', {
            detail: { href: url },
            bubbles: true,
          })
        );
      }
      window.location.href = url;
      showPageLoader();
    });

    this.upcomingVisibility();
  }

  get isUpcomingSelected() {
    return Boolean(
      this.upcomingOption && this.customSelect?.querySelector('input')?.value === this.upcomingOption.dataset.value
    );
  }

  generateUrl(value, isEdition) {
    const url = new URL(window.location.href);
    const key = isEdition ? 'edition' : 'release';
    const oldKey = isEdition ? 'release' : 'edition';
    url.searchParams.set(key, value);
    url.searchParams.delete(oldKey);
    url.searchParams.delete('cid');

    if (window.location.hostname.includes('local')) {
      let path = url.pathname;
      if (path.includes(oldKey)) path = path.replace(oldKey, key);
      const segment = path.split('.').find((part) => part.includes(key));
      if (segment) {
        path = path.replace(segment, segment.replace(segment.split('-')[1], encodeURIComponent(value)));
      } else {
        path = path.replace('.html', `.${key}-${encodeURIComponent(value)}.html`);
      }
      url.pathname = path;
    }

    return url.toString();
  }

  upcomingVisibility() {
    document.querySelector('.showForUpcomingRelease')?.classList.toggle('d-none', !this.isUpcomingSelected);
  }

  setView(view) {
    const upcoming = this.upcomingOption;
    const alert = this.upcomingAlert;
    let upcomingSelected;

    if (view === 'instructor') {
      upcoming?.classList.remove('disabled');
      upcoming?.setAttribute('aria-disabled', 'false');
      upcoming?.setAttribute('tabindex', '0');
      upcoming?.removeAttribute('aria-label');
      if (upcoming && alert) {
        upcomingSelected = this.isUpcomingSelected;
        if (!upcomingSelected) alert.classList.remove('d-none');
      }
    } else if (view === 'student') {
      upcoming?.classList.add('disabled');
      upcoming?.setAttribute('aria-disabled', 'true');
      upcoming?.setAttribute('tabindex', '-1');
      upcoming?.setAttribute('aria-label', `${upcoming.textContent.trim()}, disabled`);
      alert?.classList.add('d-none');

      if (this.upcomingBadgeOption && this.inputBadge?.textContent.includes(UPCOMING_BADGE)) {
        const dropdown = document.querySelector('.dropdown.customSelect');
        const options = Array.from(dropdown?.querySelectorAll('.customSelectOption') || []);
        const alternative = options.find((option) => !option.classList.contains('isUpcoming'));
        if (alternative) {
          dropdown.customSelectInstance?.selectOption(options.indexOf(alternative));
        } else {
          dropdown?.classList.add('d-none');
          document.querySelector('.showForUpcomingRelease')?.classList.add('d-none');
        }
      }
    }

    if (upcoming) {
      this.element.dispatchEvent(
        new CustomEvent('studentInstructorToggleStudentState', {
          detail: { value: upcomingSelected },
          bubbles: true,
        })
      );
    }

    if (this.customSelect) {
      window.CustomSelect.getOrCreateInstance(this.customSelect);
      const count = this.customSelect.querySelectorAll('.customSelectOption').length;
      if (count === 0) {
        this.element.classList.add('d-none');
      } else {
        this.customSelect.classList.remove('d-none');
        this.element.querySelector('.releasePopover')?.classList.remove('d-none');
        this.element.querySelector('.singleOptionView')?.classList.add('d-none');
      }
    }
  }
}
